import { InjectionToken } from '@angular/core';

export const AFTER_LOGIN_REDIRECT_URL_PROVIDER = new InjectionToken<AfterLoginRedirectUrlProvider>(
    'AFTER_LOGIN_REDIRECT_URL_PROVIDER'
);

/**
 * This provider is to redirect to the given URL after the login redirection.
 * When not given it return to the current URL.
 */
export interface AfterLoginRedirectUrlProvider {
    set(url?: string): void;
    get(): string | undefined;
}
